// extracted by mini-css-extract-plugin
module.exports = {"newContextMenu":"styles_newContextMenu__z_UCg","menuItems":"styles_menuItems__2sPzK"};